import styled from 'styled-components';

export const TooltipStyle = {
  Tooltip: styled.div`
    background: #ffffff;
    border-radius: 2px;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.18);
    box-sizing: border-box;
    display: flex;
    font-size: 8px;
    line-height: 10px;
    width: fit-content;
  `,
  Date: styled.div`
    color: ${({ theme }) => theme.legacy.secondary};
    font-size: 8px;
    font-weight: bold;
    line-height: 10px;
    margin: 4px;
  `,
  Divider: styled.div`
    background: ${({ theme }) => theme.legacy.lightGrey};
    width: 1px;
  `,
};
